import { render, staticRenderFns } from "./rank.vue?vue&type=template&id=c2e891a8&scoped=true"
import script from "./rank.vue?vue&type=script&lang=js"
export * from "./rank.vue?vue&type=script&lang=js"
import style0 from "./rank.vue?vue&type=style&index=0&id=c2e891a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e891a8",
  null
  
)

export default component.exports